import { render } from "./BudgetProcessPreview.vue?vue&type=template&id=398d5061&scoped=true"
import script from "./BudgetProcessPreview.vue?vue&type=script&lang=js"
export * from "./BudgetProcessPreview.vue?vue&type=script&lang=js"

import "./BudgetProcessPreview.vue?vue&type=style&index=0&id=398d5061&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398d5061"]])

export default __exports__